<template>
    <div class="bg-[#23242A] h-screen overflow-y-auto p-5">
      <div class="p-3 bg-[#2B2C32] border-0 rounded-lg">

        <template v-if="vg_selectedLocation.id">
          <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]" v-if="loading">
              <block-loading />
          </div>

          <template v-else>
            <div class="text-[24px] text-white font-semibold mb-3 flex justify-between">
              Settings
              <button @click=" createLocationLot()" class="text-sm font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-white hover:text-white hover:bg-theme-darkgreen">SAVE</button>
            </div>


            <div class="py-2 grid gap-4 xl:grid-cols-4 grid-cols-1">
            
              <div :class="'input-wrapper ' + (form.cannabisWeightLimit.error_type)">
                <label class="block text-white text-xs mb-1" for="company">Cannabis limit</label>
                <input @keyup="validateFields(['cannabisWeightLimit'])" v-model="form.cannabisWeightLimit.value" class="appearance-none rounded w-full py-2.5 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline text-sm"  placeholder="Cannabis Limit" type="number">
                <p class="field-error label-text mt-1" v-if="form.cannabisWeightLimit.error_message" v-text="form.cannabisWeightLimit.error_message"></p>
              </div>

    
              <div class="input-wrapper">
                <label class="block text-white text-xs mb-2" for="company">Lot tracking</label>
                <div class="flex items-center cursor-pointer" @click.prevent="form.lotTracking = !form.lotTracking"> 
                    <input type="checkbox" v-model="form.lotTracking" class="hidden peer">
                    <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.lotTracking ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                    <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.lotTracking ? 'text-theme-green' : 'text-[#F53333]'">{{form.lotTracking ? 'On' : 'Off'}}</span>
                </div>
              </div>
              
            </div>
          </template>
        </template>

        <div class="bg-[#2B2C32] rounded-lg px-8 py-1" v-else>
          <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
        </div>


      </div>
    </div>
  </template>
  
  
  <script lang="ts">
  
  import {defineComponent, ref} from "vue"
  import LocationCannabisSetting from '@/controllers/LocationCannabisSetting';
  import { mapGetters, mapActions } from "vuex";
  import Helpers from '@/helpers';
  import { useSnackbar } from "vue3-snackbar";
  import router from '@/router';

  
  export default defineComponent({
    name: "LocationLotTracking",
    setup() {
        const snackbar = useSnackbar();
        const loading = ref(false);
        const form = ref({
            cannabisWeightLimit: {
                value: 0,
                error_type: '',
                error_message: '',
                validations: ['required_min_0'],
            },

          lotTracking: false,
        });
        const locationLotTraking = ref({});
      
      return {
        form,
        loading,
        locationLotTraking,
        snackbar
      };
    },
  
    computed: {
      ...mapGetters({
        vg_userToken: 'auth/userToken',
        va_activeBusiness: 'auth/activeBusiness',
        vg_selectedLocation: 'location/selected'
      }),
    },

    watch : {
      'vg_selectedLocation'(val) {
        if(this.vg_userToken){
          // if location selected clear component
          this.fetchLocationLot();
        }else{
          router.push('/login?sessionExpired=1')
        }
      },
    },
   
  
    async mounted() {
      if(this.vg_selectedLocation.id){
        this.loading = true;
        await this.fetchLocationLot();
        this.loading = false;
      }
    },
  
    methods: {
  
      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },
  
      
  
      /**
       * Create business branding
       */
      async createLocationLot() {
        // validate business field
        let validate = await this.validateFields(['cannabisWeightLimit']);
        if(!validate) {
          return ;
        }
        this.va_spinner(true);
       
        let res = await LocationCannabisSetting.create(Helpers.getFormKeyValue(this.form));
        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: (res.status == 201 || res.status == 200) ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
  
      },
  


      /**
       * Fetch business lot
       */
       async fetchLocationLot() {
        let res = await LocationCannabisSetting.fetchSetting();
        this.form.cannabisWeightLimit.value =  res.status == 200 ? res.data.payload.cannabisWeightLimit : 0;
        this.form.lotTracking =  res.status == 200 ? res.data.payload.lotTracking : false;

       },
  
  
      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
  
    },
  });
  
  </script>
  
  